import R from 'ramda';

import MainDispatcher from '../support/MainDispatcher';
import store from './Store';

/* ------------------------------ DEPRECATED ---------------------------------
NOTE: This is an usage of our old flux implementation. While still in use in
many places, any NEW client-side state management needs with apps
should be done with Redux in:

* client/common/reducers/AppReducer
* client/common/actions/AppActions
 -------------------------------------------------------------------------- */

var _currentAppId = null,
  _currentApp = {},
  _warnings = {},
  _errors = [],
  _events = [],
  _branchKeyResetting = false,
  _branchSecretResetting = false,
  _appListComplete = false;

function isLiveApp(currentApp, currentAppId) {
  return currentApp && currentAppId === currentApp.live_id;
}

var AppsStore = store({
  getApp: function() {
    return _currentApp;
  },
  getAppId: function() {
    return _currentAppId;
  },
  getPairAppId: function() {
    return _currentApp && _currentApp.pair_id;
  },
  isLive: function() {
    return isLiveApp(_currentApp, _currentAppId);
  },
  getWarnings: function() {
    return _warnings;
  },
  // This should probably move somewhere else.
  getErrors: function() {
    return _errors;
  },
  // This should probably move somewhere else too.
  getEvents: function() {
    return _events;
  },
  getKeyResetLoading: function() {
    return _branchKeyResetting;
  },
  getSecretResetLoading: function() {
    return _branchSecretResetting;
  },
  getAppListComplete: function() {
    return _appListComplete;
  }
});

AppsStore.dispatchToken = MainDispatcher.register(function(action) {
  switch (action.action) {
    case 'APP_LOAD':
      _appListComplete = true;
      _currentAppId = action.current_app_id;
      _currentApp = action.current_app;

      AppsStore.emitChange();
      break;

    case 'APP_CHANGE':
      _currentAppId = action.app_id;
      _currentApp = null;
      _errors = null;
      AppsStore.emitChange();
      break;

    case 'ENTITY_SAVED':
      if (!_currentApp.id) {
        break;
      }
      for (var k in action.app) {
        if (action.app.hasOwnProperty(k)) {
          _currentApp[k] = action.app[k];
        }
      }
      _errors = null;
      AppsStore.emitChange();
      break;
    case 'UPDATE_CUSTOM_SUBDOMAIN':
      var is_live = isLiveApp(_currentApp, _currentAppId);

      if (is_live) {
        _currentApp = R.merge(_currentApp, {
          default_short_url_domain: action.subdomain.live,
          alternate_short_url_domain: action.subdomain.live_alternate,
          subdomain_changed_count: _currentApp.subdomain_changed_count
            ? _currentApp.subdomain_changed_count++
            : 1
        });
      } else {
        _currentApp = R.merge(_currentApp, {
          default_short_url_domain: action.subdomain.test,
          alternate_short_url_domain: action.subdomain.test_alternate,
          subdomain_changed_count: _currentApp.subdomain_changed_count
            ? _currentApp.subdomain_changed_count++
            : 1
        });
      }
      AppsStore.emitChange();
      break;
    case 'APP_ARCHIVED':
      _currentApp.archived_date = new Date().toISOString();
      AppsStore.emitChange();
      break;

    case 'APP_UNARCHIVED':
      _currentApp.archived_date = null;
      AppsStore.emitChange();
      break;

    case 'ENTITY_ERROR':
      _errors = _errors || [];
      _errors.push(action.errors || action.error);
      AppsStore.emitChange();
      break;

    case 'BRANCH_RESET_KEY_LOADING':
      _branchKeyResetting = true;
      _errors = null;
      AppsStore.emitChange();
      break;

    case 'BRANCH_RESET_KEY_LOADED':
      _branchKeyResetting = false;
      _errors = null;
      _currentApp.branch_key = action.branch_key;
      _currentApp.old_branch_key = action.old_branch_key;
      _currentApp.old_branch_key_expiration = action.old_branch_key_expiration;
      AppsStore.emitChange();
      break;
    case 'BRANCH_RESET_SECRET_LOADING':
      _branchSecretResetting = true;
      AppsStore.emitChange();
      break;

    case 'BRANCH_RESET_SECRET_LOADED':
      _branchSecretResetting = false;
      _errors = null;
      _currentApp.branch_secret = action.branch_secret;
      _currentApp.old_branch_secret = action.old_branch_secret;
      _currentApp.old_branch_secret_expiration =
        action.old_branch_secret_expiration;
      AppsStore.emitChange();
      break;
  }
});

export default AppsStore;

AppsStore.NO_APP = 0;
AppsStore.STORE_REDIRECT = 1;
AppsStore.CUSTOM_REDIRECT = 2;
